import React from 'react';

import './CommetyBody.scss';
import img from './../../images/WAS.png';

function CommetyBody(props) {
  return (
    <div className="commety-body">
      <div className="commety-body__left">
        <div className="commety-body__img-box">
          <img src={img} alt="" className="commety-body__img" />
        </div>
        <h3 className="commety-body__title">United Nations Security Council</h3>
        <div className="commety-body__description-box">
          <p className="commety-body__description">{props.description}</p>
          <div className="commety-body__description-gap">aaaa</div>
          <p className="commety-body__description">{props.description}</p>
        </div>
      </div>
      <div className="commety-body__right">
        <div className="commety-body__agendas-box">
          <div className="commety-body__agendas-title">Agendas</div>
          <ul className="commety-body__agendas">
            <li className="commety-body__agendas-item">- {props.agenda}</li>
            <li className="commety-body__agendas-item">- {props.agenda}</li>
          </ul>
        </div>
        <div className="commety-body__level-box">
          <div className="commety-body__level-title">Level</div>
          <div className="commety-body__level">{props.level}</div>
        </div>
        <div className="commety-body__vacancy-box">
          <div className="commety-body__vacancy-title">Vacancy</div>
          <div className="commety-body__vacancy">
            <span className="commety-body__vacancy-number">
              {props.vacancy}
            </span>{' '}
            <span>Seats Remaining*</span>
          </div>
          <div className="commety-body__vacancy-text">
            *Country allocation would be communicated via email.
          </div>
        </div>
      </div>
    </div>
  );
}

export default CommetyBody;
